module.exports = {
	"name": "Name",
	"yourMessage": "Your Message",
	"errors": {
		"isRequired": "This field is required."
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/constants/contactDealerCopy.json
// module id = 2580
// module chunks = 4